import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import base from '@/_api/base';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function useAttractionsQuery(festivalId) {
  return useGetQuery(
    () => `/admin/attractions/${festivalId}`,
    {},
    queryKeys.attractions(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function useSaveAttractionMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (attraction) => `/admin/attraction/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.attractions(festivalId),
        });
        NotificationManager.success('Attraction saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Attraction not saved', 'Error', 3000);
      },
    },
  );
}

export function useRemoveAttractionMutation(festivalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (attractionId) =>
      base.delete(`/admin/attraction/${attractionId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.attractions(festivalId),
      });
      NotificationManager.success('Attraction removed', '', 3000);
    },
    onError: () => {
      NotificationManager.error('Attraction could not be removed', '', 3000);
    },
  });
}
